import React from 'react';
import { Link } from 'react-router-dom';

import * as s from './AuthorLink.css';

interface IAuthorLink {
  name: string;
  path?: string;
}

/**
 * Ссылка на страницу автора
 */
export const AuthorLink = ({ name, path }: IAuthorLink) => {
  return <div className={s['wrapper']}>{path ? <Link to={path}>{name}</Link> : name}</div>;
};
